var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivefav({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5371 9.05085L10.5487 15.0403C10.1517 15.4372 9.6133 15.6602 9.05191 15.6602C8.49051 15.6602 7.9521 15.4372 7.55507 15.0403L1.56668 9.05191C1.07166 8.5612 0.678431 7.97755 0.409578 7.33446C0.140724 6.69137 0.001539 6.00152 1.26909e-05 5.30449C-0.00151362 4.60747 0.134649 3.91701 0.400684 3.27275C0.666718 2.62849 1.05738 2.04313 1.55026 1.55026C2.04313 1.05738 2.62849 0.666718 3.27275 0.400683C3.91701 0.134649 4.60747 -0.00151362 5.30449 1.2691e-05C6.00152 0.001539 6.69137 0.140724 7.33446 0.409578C7.97755 0.678431 8.5612 1.07166 9.05191 1.56668C10.0486 0.594769 11.3881 0.0546746 12.7803 0.0633972C14.1724 0.0721199 15.505 0.628957 16.4895 1.61328C17.4739 2.59761 18.031 3.93017 18.0399 5.32229C18.0488 6.7144 17.5089 8.05399 16.5371 9.05085Z",
    fill: "#F98700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivefav);
export default __webpack_public_path__ + "static/media/activefav.3d445127231aae53ad928d2a1c526571.svg";
export { ForwardRef as ReactComponent };